import React, { useCallback } from 'react';
import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import { Button } from 'ui-components/components/button';
import { useEntitiesFulfillmentPlanProperty } from '../../hooks/entities/selectors/fulfillment-plans';
import { restoreCancelledShipment } from '../../store/orders/orders.api';
import PropTypes from 'prop-types';
import messages from '../../components/restore/messages';
import {
  NotificationService,
  NOTIFICATION_DURATIONS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
} from 'ui-components/services/notification-service';
import { restoreFulfillmentsSuccess } from '../../store/orders/orders.actions';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

export const RestoreCancelledButton = ({ fulfillmentPlanId }) => {
  const orderGridStatus = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'orderGridStatus');

  const dispatch = useDispatch();

  const restore = useCallback(() => {
    restoreCancelledShipment([fulfillmentPlanId])
      .then(() => {
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          title: <FormattedMessage {...messages.restoreShipmentSuccessTitle} />,
          content: <FormattedMessage {...messages.restoreShipmentSuccessMessage} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
        dispatch(restoreFulfillmentsSuccess(fulfillmentPlanId));
      })
      .catch(() => {
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_ERROR,
          title: <FormattedMessage {...messages.restoreShipmentErrorTitle} />,
          content: <FormattedMessage {...messages.restoreShipmentErrorMessage} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      });
  }, [dispatch, fulfillmentPlanId]);

  if (orderGridStatus !== FulfillmentPlanOrderGridStatus.Cancelled.name) {
    return null;
  }

  return (
    <Button onClick={restore} theme='primary'>
      <FormattedMessage {...messages.restoreButton} />
    </Button>
  );
};

RestoreCancelledButton.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
